import {NgModule} from '@angular/core';
import {CadCamService} from '@infrastructure/cad-cam/cad-cam.service';
import {SharedModule} from '@shared/shared.module';

@NgModule({
  imports: [SharedModule],
  providers: [CadCamService]
})
export class DrawingLibraryDetailsModule {}
//
